const EnumPol = {
    ODABERITE_POL: -1,
    ZENSKI: 0,
    MUSKI: 1,
};

export default EnumPol;